<template>
  <v-app>
    <dashboard-core-app-bar v-model="expandOnHover" />

    <dashboard-core-drawer :expand-on-hover.sync="expandOnHover" />

    <dashboard-core-view />

    <calendar-core-drawer />
    
    <chat-core v-if="!hide" />
  </v-app>
</template>

<script>

/*eslint-disable */

import { mapMutations, mapActions } from "vuex";
export default {
  name: "DashboardIndex",

  components: {
    DashboardCoreAppBar: () => import("./components/core/AppBar"),
    DashboardCoreDrawer: () => import("./components/core/Drawer"),
    CalendarCoreDrawer: () => import("./components/core/CalendarDrawer"),
    DashboardCoreView: () => import("./components/core/View"),
    ChatCore: () => import("../../components/chat/groupChat/Chat"),
  },

  data: () => ({
    expandOnHover: false,
    scY: 0,
    hide: true
  }),

  created(){
    this.getUser()
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    ...mapActions({
      "getUser": "users/getUser"
    }),

    ...mapMutations({
      setChat: "SET_CHAT",
    }),

    handleScroll() {
      this.scY = window.scrollY;
      if (this.scY > 400) return this.setChat(false);
      this.setChat(true);
    },
  },
};
</script>
